const Alchemy = require('../ability_trees/Alchemy.js');
const BowUse = require('../ability_trees/BowUse.js');
const Illusion = require('../ability_trees/Illusion.js');
const StandardAbilityTree = require('../ability_trees/StandardAbilityTree.js');

const ItemGenerator = require('../../game_items/ItemGenerator.js');
const MedHelmet = require('../../game_items/equipment/helmet/MedHelmet.js');
const MedTorsoe = require('../../game_items/equipment/torsoe/MedTorsoe.js');
const MedBoots = require('../../game_items/equipment/boots/MedBoots.js');
const Bow = require('../../game_items/equipment/off_hand/Bow.js');

module.exports = {
  handle: 'assassin',
  getAbilityTrees: () => ([
    Alchemy,
    BowUse,
    Illusion,
    StandardAbilityTree,
  ]),
  getBaseAttributes: () => ({
    learning: 6,
    perception: 10,
    mana: 5,
    toughness: 6,
    strength: 8,
    willpower: 5,
    dexterity: 10,
  }),
  getDefaultAIConfig: () => (['dps_ranged', 'interference', 'dps_close', 'tank', 'support']),
  getStarterEquipment: () => ({
    helmet: ItemGenerator.getRandomItem(MedHelmet, 0, 0.1, true),
    torsoe: ItemGenerator.getRandomItem(MedTorsoe, 0, 0.1, true),
    boots: ItemGenerator.getRandomItem(MedBoots, 0, 0.1, true),
    off_hand: ItemGenerator.getRandomItem(Bow, 0, 0.1, true),
  }),
};
